import {
  ARCHIVE_BUSINESS_LOYALTY_PROGRAM_OPERATION,
  CREATE_BUSINESS_LOYALTY_PROGRAM_OPERATION,
  LIST_BUSINESS_LOYALTY_PROGRAMS_OPERATION,
  UPDATE_BUSINESS_LOYALTY_PROGRAM_OPERATION,
  type GeneratedArchiveBusinessLoyaltyProgramResponse,
  type GeneratedCreateBusinessLoyaltyProgramRequest,
  type GeneratedCreateBusinessLoyaltyProgramResponse,
  type GeneratedListBusinessLoyaltyProgramsResponse,
  type GeneratedUpdateBusinessLoyaltyProgramRequest,
  type GeneratedUpdateBusinessLoyaltyProgramResponse,
} from './generated-business';
import { performAuthorizedRequest, replacePathParams } from './business-request';

export async function listBusinessLoyaltyProgramsRequest(
  token: string,
  businessId: number
): Promise<GeneratedListBusinessLoyaltyProgramsResponse> {
  return performAuthorizedRequest<GeneratedListBusinessLoyaltyProgramsResponse>(
    token,
    {
      ...LIST_BUSINESS_LOYALTY_PROGRAMS_OPERATION,
      path: replacePathParams(LIST_BUSINESS_LOYALTY_PROGRAMS_OPERATION.path, {
        business_id: businessId,
      }),
    },
    {
      networkErrorMessage:
        'Não foi possível obter os programas de fidelização. Verifique se o backend está disponível.',
      requestErrorMessage:
        'Não foi possível carregar os programas de fidelização agora.',
    }
  );
}

export async function createBusinessLoyaltyProgramRequest(
  token: string,
  businessId: number,
  loyaltyProgram: GeneratedCreateBusinessLoyaltyProgramRequest
): Promise<GeneratedCreateBusinessLoyaltyProgramResponse> {
  return performAuthorizedRequest<GeneratedCreateBusinessLoyaltyProgramResponse>(
    token,
    {
      ...CREATE_BUSINESS_LOYALTY_PROGRAM_OPERATION,
      path: replacePathParams(CREATE_BUSINESS_LOYALTY_PROGRAM_OPERATION.path, {
        business_id: businessId,
      }),
    },
    {
      body: loyaltyProgram,
      networkErrorMessage:
        'Não foi possível criar o programa de fidelização. Verifique se o backend está disponível.',
      requestErrorMessage:
        'Não foi possível criar o programa de fidelização agora.',
    }
  );
}

export async function updateBusinessLoyaltyProgramRequest(
  token: string,
  businessId: number,
  loyaltyProgramId: number,
  loyaltyProgram: GeneratedUpdateBusinessLoyaltyProgramRequest
): Promise<GeneratedUpdateBusinessLoyaltyProgramResponse> {
  return performAuthorizedRequest<GeneratedUpdateBusinessLoyaltyProgramResponse>(
    token,
    {
      ...UPDATE_BUSINESS_LOYALTY_PROGRAM_OPERATION,
      path: replacePathParams(UPDATE_BUSINESS_LOYALTY_PROGRAM_OPERATION.path, {
        business_id: businessId,
        id: loyaltyProgramId,
      }),
    },
    {
      body: loyaltyProgram,
      networkErrorMessage:
        'Não foi possível atualizar o programa de fidelização. Verifique se o backend está disponível.',
      requestErrorMessage:
        'Não foi possível atualizar o programa de fidelização agora.',
    }
  );
}

export async function archiveBusinessLoyaltyProgramRequest(
  token: string,
  businessId: number,
  loyaltyProgramId: number
): Promise<GeneratedArchiveBusinessLoyaltyProgramResponse> {
  return performAuthorizedRequest<GeneratedArchiveBusinessLoyaltyProgramResponse>(
    token,
    {
      ...ARCHIVE_BUSINESS_LOYALTY_PROGRAM_OPERATION,
      path: replacePathParams(ARCHIVE_BUSINESS_LOYALTY_PROGRAM_OPERATION.path, {
        business_id: businessId,
        id: loyaltyProgramId,
      }),
    },
    {
      networkErrorMessage:
        'Não foi possível arquivar o programa de fidelização. Verifique se o backend está disponível.',
      requestErrorMessage:
        'Não foi possível arquivar o programa de fidelização agora.',
    }
  );
}
